import { useMemo } from 'react';

import { css } from '@emotion/react';
import { responsive, useTheme } from '@wci-tech/core-ui';

import { getContainerStyles } from '@/utils';

export const useStyles = () => {
  const { theme } = useTheme();

  return useMemo(
    () => ({
      imageContainer: css`
        background-color: transparent;
      `,

      container: css`
        ${getContainerStyles(theme)};
      `,

      titleWrapper: css`
        ${responsive.create({
          marginBottom: {
            default: theme.spacing.get(16),
            md: theme.spacing.get(24),
            lg: theme.spacing.get(32),
          },
        })}
      `,

      contentWrapper: css`
        background-color: transparent;
        ${responsive.create({
          maxWidth: {
            default: '300px',
          },
          marginTop: {
            default: theme.spacing.get(-20),
            md: theme.spacing.get(-56),
          },
        })}
      `,

      primaryTitle: css`
        color: var(--heading-text-color);
        transition: color 0.3s ease;
        ${responsive.create({
          lineHeight: {
            md: 1.1,
          },
        })}
      `,

      secondaryTitle: css`
        color: var(--brand-color);
        transition: color 0.3s ease;
      `,

      description: css`
        color: var(--desc-text-color);
        transition: color 0.3s ease;

        ${responsive.create({
          fontSize: {
            default: theme.fonts.size.xs,
            sm: theme.fonts.size.sm,
            lg: theme.fonts.size.md,
            xl: theme.fonts.size.xl,
          },
        })}
      `,

      tokenName: css`
        color: var(--text-color);
        transition: color 0.3s ease;
      `,
    }),
    [theme],
  );
};
